import { AssistantActionConst } from "../Constants/AssistantConstants";

const initialState = {
  list: [],
  loading: false,
  error: null,
  createLoading: false,
  createError: null,
  updateLoading: false,
  updateError: null,
  deleteLoading: false,
  deleteError: null,
};

const assistantReducer = (state = initialState, action) => {
  switch (action.type) {
    case AssistantActionConst.FETCH_REQUEST:
      return { ...state, loading: true, error: null };
    case AssistantActionConst.FETCH_SUCCESS:
      return { ...state, loading: false, list: action.payload || [] };
    case AssistantActionConst.FETCH_FAIL:
      return { ...state, loading: false, error: action.payload };

    case AssistantActionConst.CREATE_REQUEST:
      return { ...state, createLoading: true, createError: null };
    case AssistantActionConst.CREATE_SUCCESS:
      return {
        ...state,
        createLoading: false,
        list: [action.payload, ...state.list],
      };
    case AssistantActionConst.CREATE_FAIL:
      return { ...state, createLoading: false, createError: action.payload };

    case AssistantActionConst.UPDATE_REQUEST:
      return { ...state, updateLoading: true, updateError: null };
    case AssistantActionConst.UPDATE_SUCCESS:
      return {
        ...state,
        updateLoading: false,
        list: state.list.map((a) => (a.id === action.payload.id ? action.payload : a)),
      };
    case AssistantActionConst.UPDATE_FAIL:
      return { ...state, updateLoading: false, updateError: action.payload };

    case AssistantActionConst.DELETE_REQUEST:
      return { ...state, deleteLoading: true, deleteError: null };
    case AssistantActionConst.DELETE_SUCCESS:
      return {
        ...state,
        deleteLoading: false,
        list: state.list.filter((a) => a.id !== action.payload),
      };
    case AssistantActionConst.DELETE_FAIL:
      return { ...state, deleteLoading: false, deleteError: action.payload };

    case AssistantActionConst.CLEAR_STATUS:
      return {
        ...state,
        createLoading: false,
        createError: null,
        updateLoading: false,
        updateError: null,
        deleteLoading: false,
        deleteError: null,
      };

    default:
      return state;
  }
};

export default assistantReducer;
